import { ProjectInfo } from '@frontend-site/shared/data';
import { MenuItem } from '../../../models';
import { MENU_IDS } from '../../menu-ids';

export function createDefectsMenu(projectInfo: ProjectInfo): MenuItem | null {
    if (projectInfo.isRestrictedApp()) {
        return null;
    }
    if (!showDefects(projectInfo)) {
        return null;
    }

    return {
        id: MENU_IDS.PROJECT.DEFECTS.DEFAULT,
        label: 'Enumerations.ApplicationModules.DEFECTS',
        routePath: `/${projectInfo.id}/defects`,
        menu: [
            {
                id: MENU_IDS.PROJECT.DEFECTS.DEFAULT,
                label: 'Enumerations.ApplicationModules.DEFECTS',
                routePath: `/${projectInfo.id}/defects/list`
            },
            {
                id: MENU_IDS.PROJECT.DEFECTS.SITE_WIDE_DEFECTS,
                label: 'Execution.NavBar.systemWideDefects',
                routePath: `/${projectInfo.id}/system-wide-defects/view`
            }
        ]
    };
}

export function showDefects(projectInfo: ProjectInfo): boolean {
    if (projectInfo.isIcr3Project()) {
        return false;
    }
    if (projectInfo.isSalesforceProject()) {
        if (projectInfo.hasTestsModule()) {
            return true;
        } else {
            return false;
        }
    }

    return !projectInfo.testCatalog && !projectInfo.qc;
}
